var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useRef } from 'react';







export const SelectFileButton = ({ onFileImported, children, id }) => {
  // @ts-ignore
  const fileInputRef = useRef();

  const show = () => {
    if (fileInputRef.current !== null) {var _fileInputRef$current;
      (_fileInputRef$current = fileInputRef.current) === null || _fileInputRef$current === void 0 ? void 0 : _fileInputRef$current.click();
    }
  };

  const select = (e) => {
    const file = e.target.files[0];
    if (file) {
      onFileImported(file);
    }
  };

  return /*#__PURE__*/(
    _jsx("div", { onClick: show, style: { display: 'inline' } }, void 0,
    children, /*#__PURE__*/
    _jsx("label", { htmlFor: id, style: { display: 'none' } }, void 0,
    id
    ), /*#__PURE__*/
    React.createElement("input", {
      ref: fileInputRef,
      type: "file",
      accept: "text/csv",
      style: { display: 'none' },
      onChange: select,
      id: id }
    )
    ));

};